module.exports = __webpack_public_path__ + "img/liver.0f8eb57f.png";